import React__default, { useMemo } from 'react';
import { selectQuestionTypeDefinition, isExternalQuestionWithTypeId } from '@sm/question-definitions';
import { withErrorBoundary } from '@sm/question-ui/helpers';
import { u as useProviderAccessContext, a as useExternalQuestionAugmentation, c as createVisualization } from './utils-3f92f024.js';

function UnsupportedQuestionTypeError({
  question
}) {
  const typeId = isExternalQuestionWithTypeId(question) && question.typeId;
  return React__default.createElement("div", null, "Unsupported Question Type: ", typeId);
}

function SingleQuestionController({
  question: externalQuestion,
  displayOptions,
  namedSlots,
  responseSet
}) {
  const {
    useUpstreamConfig,
    useVisualizationList
  } = useProviderAccessContext();
  const {
    capability,
    upstreamActions,
    renderProps,
    settings
  } = useUpstreamConfig();
  /* NOTE:
  Since Controllers are expected to be capability-independent -- and should not import
  the CapabilityProvider types -- this config is returning the type params as `unknown`s.
  This shouldn't be a problem -- as the Controller doesn't need to know
  any specifics about these types - other than passing them to the compatible
  Visualizations (something that the Visualization Helpers runtime already takes
  care of). However, the consequence is that overall type safety of the Controller
  is not as strict as we would like it to be. We should probably create a task
  to improve this later.
  */
  // TODO: add controller type to the visualization selection -- to allow for different DisplayOptions and better support for nested visualizations

  const visualizationOptions = useVisualizationList(capability
  /* , controllerType */
  ); // Augment the external question with the type id

  const augmentedExternalQuestion = useExternalQuestionAugmentation(externalQuestion, responseSet);
  const definition = selectQuestionTypeDefinition(augmentedExternalQuestion);
  const ChosenVisualization = useMemo(() => {
    if (!definition) {
      return null;
    } // Is this React.memo necessary?


    return React__default.memo(createVisualization(capability, definition.typeId, visualizationOptions, upstreamActions, settings, renderProps)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [//* * Revisit / Hoist */
  // capability, // causes constant re-renders
  definition === null || definition === void 0 ? void 0 : definition.typeId // settings,  // causes constant re-renders
  // renderProps,  // causes constant re-renders
  // definition,  // causes constant re-renders
  // upstreamActions, // causes constant re-renders
  // visualizationOptions, // causes constant re-renders
  ]);

  if (ChosenVisualization === null || !definition) {
    return React__default.createElement(UnsupportedQuestionTypeError, {
      question: augmentedExternalQuestion
    });
  }

  const toExternalQuestion = q => definition.toExternalQuestion(externalQuestion, q, capability);
  /* NOTE:
  Type safety improvement: Currently 'QuestionType' is all the possible question types
  -- while createVisualization will choose a visualization that can render
  question types for a specific capability -- meaning that the resulting question
  type of 'ChosenVisualization' is a subset of all the possible QuestionTypes
  (only those that have viable visualizations for that capability -- and, in the
  future, ControllerType)
  */


  const question = definition.fromExternalQuestion(augmentedExternalQuestion, capability);
  return React__default.createElement(ChosenVisualization, {
    question: question,
    displayOptions: displayOptions,
    namedSlots: namedSlots,
    toExternalQuestion: toExternalQuestion
  });
}

var SingleQuestionController$1 = withErrorBoundary(SingleQuestionController);
export { SingleQuestionController$1 as S };